import { flash } from "@/utils/flash";

export const useFlashMessages = (): void => {
  const flashStore = useFlashStore();

  onMounted(() => {
    flashStore.messages.forEach((message) => {
      flash(message.type, message.message);
      flashStore.removeMessage(message.id);
    });
  });
};
